import { Block } from "../blockModel/types";
import { parse } from "../blockModel/parse";

export interface ElStyle {
	size?: number;
	color?: string;
	bold?: boolean;
	capitalize?: boolean;
	align?: string;
	bg?: string;
	radius?: number;
}

export interface Theme {
	brand: string;
	radius: number;
	font: string;
}

export interface BuilderState {
	blocks: Block[];
	theme: Theme;
	elStyle: Record<string, ElStyle>;
	selId: string | null;
	selEl: string | null;
}

let _id = 1;
export const nid = () => "b" + _id++;

export function withIds(blocks: Block[]): Block[] {
	return blocks.map((b) => ({ ...b, id: nid() }));
}

export function initialState(content: string): BuilderState {
	return {
		blocks: withIds(parse(content || "")),
		theme: { brand: "#005e9e", radius: 12, font: "system" },
		elStyle: {},
		selId: null,
		selEl: null,
	};
}
